import React from 'react';
import { useAppDispatch } from 'state/hooks';
import { updateScreenCursorState } from 'state/phonebooth/slice';
import styled from 'styled-components/macro';

import ButtonShadow from '../animations/ButtonShadow';

const Wrapper = styled.div<{ disabled?: boolean }>`
  cursor: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};

  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: ${({ disabled }) => (disabled ? 'scale(1)' : 'scale(1.05)')};
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
    cursor: pointer;
  `};
`;

const Button = styled.div<{ sizeRatio: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00ffc9;
  animation: ${ButtonShadow} 1.6s infinite;
  border-radius: ${({ sizeRatio }) => `${sizeRatio * 10}px`};
  height: ${({ sizeRatio }) => `${sizeRatio * 90}px`};
  width: ${({ sizeRatio }) => `${sizeRatio * 90}px`};
  box-shadow: 0 0 2px 5px #00ffc9, 2px 2px 2px 5px #35ffd3;

  mix-blend-mode: lighten;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 28vw;
    height: 28vw;
    border-radius: 20px;
  `};
`;

const Label = styled.h3<{ sizeRatio: number }>`
  font-family: 'Presicav';
  font-size: ${({ sizeRatio }) => `${sizeRatio * 11}px`};
  margin-top: ${({ sizeRatio }) => `${sizeRatio * 15}px`};
  color: #7fffe3e6;
  font-weight: bold;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    font-size: 13px;
    margin-top: 10px;
  `};
`;

const IconImg = styled.img<{ sizeRatio: number }>`
  height: ${({ sizeRatio }) => `${sizeRatio * 60}px`};
  width: auto;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    height: 19vw;
  `};
`;

type ScreenButtonProps = {
  label: string;
  icon: string;
  sizeRatio: number;
  onClick?: () => void;
  disabled?: boolean;
};

const ScreenButton: React.FC<ScreenButtonProps> = ({ label, icon, sizeRatio, onClick, disabled }) => {
  const dispatch = useAppDispatch();

  return (
    <Wrapper
      disabled={disabled}
      onMouseEnter={() => {
        if (!disabled) dispatch(updateScreenCursorState('pointer'));
      }}
      onMouseLeave={() => {
        if (!disabled) dispatch(updateScreenCursorState('hover'));
      }}
    >
      <Button sizeRatio={sizeRatio} onClick={onClick}>
        <IconImg sizeRatio={sizeRatio} src={icon} alt={`${label}-icon`} />
      </Button>
      <Label sizeRatio={sizeRatio}>{label}</Label>
    </Wrapper>
  );
};

export default ScreenButton;
